import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { mdiMapMarkerAlert } from '@mdi/js';
import CollapsibleSnackBar from '../CollapsibleSnackBar/CollapsibleSnackBar';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { mapMenuTabKeys } from 'client/utils/constants/appStates';
import { selectAOIMode, setMenuOpen, setMenuSelectedTab } from 'client/store/mapSlice/mapSlice';
import Button from 'client/components/aria/Button/Button';
import styles from './EnhancedMeasuresSnackBar.module.scss';
const EnhancedMeasuresSnackBar = () => {
    const intl = useIntl();
    const sensitiveAssets = useSelector(state => state?.assets?.sensitiveAssets) || [];
    const assetOwners = Array.from(new Set(sensitiveAssets.map(asset => asset.dataproviderid_fk)));
    const selectedTab = useSelector(state => state?.map?.menuSelectedTab);
    const isAoiMode = useSelector(selectAOIMode);
    const dispatch = useDispatch();
    const collapseSignal = selectedTab === mapMenuTabKeys.ENHANCED_MEASURES ? selectedTab : null;

    const handleLinkClick = () => {
        dispatch(setMenuOpen(true));
        dispatch(setMenuSelectedTab(mapMenuTabKeys.ENHANCED_MEASURES));
    };

    const link = (str) => (
        <CollapsibleSnackBar.CloseTrigger>
            <Button
                className={styles.link}
                variant="link"
                onPress={handleLinkClick}
                data-testid="enhancedMeasures.alert.viewLink"
            >
                {str}
            </Button>
        </CollapsibleSnackBar.CloseTrigger>
    );

    const richTextValues = {
        strong: str => <strong data-testid="enhancedMeasures.assetOwnersCount.expanded">{str}</strong>,
        count: () => assetOwners.length,
        link
    };

    const messageId = assetOwners.length === 1
        ? 'enhancedMeasures.alert.singular'
        : 'enhancedMeasures.alert.plural';

    const message = intl.formatMessage({ id: messageId }, richTextValues);

    const assetOwnersCount = intl.formatMessage({ id: 'enhancedMeasures.assetOwnersCount' }, {
        strong: str => <strong data-testid="enhancedMeasures.assetOwnersCount">{str}</strong>,
        count: () => assetOwners.length
    });

    const showSuppAlert = isAoiMode && sensitiveAssets.length > 0;

    return (
        showSuppAlert
            ? <SnackBar variant="notice" data-testid="enhancedMeasures.snackbar">
                <CollapsibleSnackBar
                    icon={mdiMapMarkerAlert}
                    label={intl.formatMessage({ id: 'enhancedMeasures.notification.label' })}
                    collapsedContent={assetOwnersCount}
                    collapseSignal={collapseSignal}
                    data-testid="enhancedMeasures.alert"
                    iconColor='black'
                >
                    {message}
                </CollapsibleSnackBar>
            </SnackBar>
            : null
    );
};

export default EnhancedMeasuresSnackBar;
